import React from 'react';
import { useWebSocketListener } from '../../context/useWebSocketListener';
import { WEB_SOCKET_ENTITY_TYPES } from '../../utils/WebSocketUtils';

const WorkOrderDetailListener = ({ socketContext, onMessage, entityIds }) => {
	useWebSocketListener({
		socketContext,
		onMessage,
		entityName: WEB_SOCKET_ENTITY_TYPES.WORK_ORDER,
		entityIds,
	});
	return null;
};

export default WorkOrderDetailListener;
